/** @format */

import { migrationUrl } from "../Config/Url";
import axios from "axios";

export const migrationServices = {
  getAllActive,
  create,
  migrate,
  remove,
};

async function getAllActive(params) {
  return axios
    .put(`${migrationUrl}`, params)
    .then((res) => res)
    .catch((err) => err.response);
}

async function create(oib) {
  return axios
    .post(`${migrationUrl}?request=${oib}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function migrate(oib) {
  return axios
    .post(`${migrationUrl}/execute?request=${oib}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(oib) {
  return axios
    .delete(`${migrationUrl}?request=${oib}`)
    .then((res) => res)
    .catch((err) => err.response);
}
